import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { SystemService } from "src/app/service/system.service";
import { IncidentSelectorService } from "src/app/service/incident-selector.service";
import { debug } from "util";

@Injectable({
  providedIn: "root",
})
export class AuthGuardService {
  constructor(
    public router: Router,
    private systemService: SystemService,
    public incidentSelectorService: IncidentSelectorService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    let routeUrl: string = route.url.toString();
    //console.log('canActivate routeUrl ' + routeUrl);

    return true;
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    let stateUrl: string = state.url.toString();
    //console.log('stateUrl ' + stateUrl);

    let hasRole: boolean = true;

    //console.log('this.systemService.userSessionVo ' + this.systemService.userSessionVo);

    if (this.systemService.userSessionVo !== undefined) {
      switch (stateUrl) {
        case "/databasemgmt":
          hasRole = this.systemService.hasAnyRole(["ROLE_ACCOUNT_MANAGER"]);
          break;
        case "/incidents/iap":
          hasRole = this.systemService.hasAnyRole(["ROLE_IAP"]);
          break;
        case "/incidents/inc":
          hasRole = true;
          break;
        case "/incidents/finexp":
        case "/incidents/datatransfer":
        case "/incidents/rossimport":
        case "/incidents/usergroups":
          hasRole = this.systemService.hasAnyRole(["ROLE_DATA_STEWARD"]);
          break;
        case "/incidents/resources":
          hasRole = this.canActivateSelectedSubTab();
          break;
        case "/incidents/training":
          hasRole = this.systemService.hasAnyRole(["ROLE_TRAINING_SPECIALIST"]);
          break;
        case "/incidents/reports/cost":
          hasRole = this.systemService.hasAnyRole(["ROLE_COST"]);
          break;
        case "/incidents/reports/custom":
          hasRole = true;
          break;
        case "/incidents/reports/time":
          hasRole = this.systemService.hasAnyRole(["ROLE_TIME"]);
          break;
        case "/incidents/reports/training":
          hasRole = this.systemService.hasAnyRole(["ROLE_TRAINING_SPECIALIST"]);
          break;
        case "/messageboard":
          hasRole = this.systemService.hasAnyRole(["ROLE_ACCOUNT_MANAGER"]);
          break;
        case "/users":
          hasRole = this.systemService.hasAnyRole(["ROLE_ACCOUNT_MANAGER"]);
          break;
        case "/helpdesk":
          hasRole = this.systemService.hasAnyRole(["ROLE_ACCOUNT_MANAGER"]);
          break;
      }
    }

    if (hasRole === false) {
      this.router.navigate(["/welcome"]);
    }

    return true;
  }

  canActivateSelectedSubTab(): boolean {
    let hasRole: boolean = false;

    //console.log('this.incidentSelectorService.selectedSubTab' + this.incidentSelectorService.selectedSubTab);
    if (this.systemService.userSessionVo !== undefined) {
      switch (this.incidentSelectorService.selectedSubTab) {
        case "checkin":
          hasRole =
            this.systemService.hasAnyRole(["ROLE_CHECKIN_DEMOB"]) ||
            this.systemService.hasAnyRole(["ROLE_TIME"]) ||
            this.systemService.hasAnyRole(["ROLE_COST"]);
          break;
        case "cost":
          hasRole = this.systemService.hasAnyRole(["ROLE_COST"]);
          break;
        case "demob":
          hasRole = this.systemService.hasAnyRole(["ROLE_CHECKIN_DEMOB"]);
          break;
        case "time":
          hasRole = this.systemService.hasAnyRole(["ROLE_TIME"]);
          break;
        case "training":
          hasRole = this.systemService.hasAnyRole(["ROLE_TRAINING_SPECIALIST"]);
          break;
      }
    }
    //console.log('hasRole ' + hasRole);

    return hasRole;
  }
}
